export default __webpack_public_path__ + "static/media/calendar.659ec432.svg";